import {
    comparaRegrasDepAtuaisComDepUpSell,
    qtdTotalDepentes, retornaLabelDoValorParentesco,
    validarQuantidadePet,
    validatorParentescoEmDuplicidade
} from './funcoesAuxiliaresZI';
import { categoriasPet } from '../../helpers/funcoesAuxiliares';
import { verificarExcecaoPetPorLocalidade } from '../validadoresComunsPorPlano/excecoes';

export class CorrenteCadastroZI {
    constructor(dependentes, parentesco, categorias, valoresForm, subGrupoSelecionadoUpSell) {
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.subGrupoSelecionadoUpSell = subGrupoSelecionadoUpSell;

        if (subGrupoSelecionadoUpSell) {
            this.dependentes = dependentes.filter(dependente => dependente.Status === true);
        } else {
            this.dependentes = dependentes;
        }
    }

    validarRegrasDepAtuaisComDepUpSell() {
        if (this.subGrupoSelecionadoUpSell) {
            const comparacaoDepAtualDepUpSell = comparaRegrasDepAtuaisComDepUpSell(this.dependentes, this.subGrupoSelecionadoUpSell);

            if (comparacaoDepAtualDepUpSell) {
                this.arrayMsgsErro = [
                    ...this.arrayMsgsErro,
                    comparacaoDepAtualDepUpSell
                ];
            }
        }

        return this;
    }

    possui5dependentes() {
        const qtdTotalDependentes = qtdTotalDepentes(this.dependentes);

        if (qtdTotalDependentes >= 5 && this.valoresForm.Nome) {
            this.arrayMsgsErro.push('O plano ZELO IDEAL permite apenas 5 dependentes.');
        }

        return this;
    }

    limitarQuantidadePet() {
        if (validarQuantidadePet(this.dependentes)) {
            this.arrayMsgsErro.push(`Só é permitido um dependente do tipo ${this.valoresForm.Parentesco}.`);
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    permitirDependentePetSomenteComAdicionalPet() {
        if (this.valoresForm.Parentesco.trim() === 'PET' && !categoriasPet.includes(this.valoresForm.Categoria.trim())) {
            this.arrayMsgsErro.push('Somente é permitido dependente PET que tenha como adicional referente ao PET');
        }

        return this;
    }

    excecaoPetPorLocalidade() {
        if (verificarExcecaoPetPorLocalidade(this.valoresForm.Categoria.trim(), this.valoresForm.Parentesco.trim())) {
            this.arrayMsgsErro = [];
        }

        return this;
    }
}
